// REACT STUFF
import { Helmet } from 'react-helmet';
import {
  React,
  useState,
  useEffect
} from 'react';
import { useParams } from "react-router-dom";
import PropTypes from 'prop-types';
import {
  Box,
  Card,
  CardContent,
  Container,
  Grid,
  Select,
  Tab,
  MenuItem,
  InputLabel,
  FormControl,
} from '@mui/material';

import {TabContext, TabList,TabPanel} from '@mui/lab'

// PAGES & COMPONENSTS
import DataDashboard from 'src/components/dashboard/DataComponents/DataDashboard';
import ControlDashboard from 'src/components/dashboard/ControlComponents/ControlDashboard';
import ConversionEfficiencyCard from 'src/components/dashboard//ConversionEfficiencyCard';
import CollectedEnergyCard from 'src/components/dashboard//CollectedEnergyCard';
import DniCard from 'src/components/dashboard/DniCard';
import LastUpdatedCard from 'src/components/dashboard//LastUpdatedCard';

// UTILS
import { dishes_url,all_dishes_url } from 'src/utils/constants';
import { getDaysEfficiencyTotal } from 'src/utils/dataProcessing';

import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

const getDishes = async (token, siteId) => {
  let url = all_dishes_url
  if (siteId !== "1" ){
    url =dishes_url+siteId
  }
  return fetch(url, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: 'Token ' + token
    }
  }).then((response) => {
    if (response.ok) return response.json();
    throw response;
  }).catch((err) => {
    console.error(err);
    // setError(err);
  });
};

const Dashboard = (props) => {
  const [daysIncident, setDaysIncident] = useState([]);
  const [daysCollected, setDaysCollected] = useState([]);

  const [selectedTab, setSelectedTab] = useState('1');

  const [totalIncident, setTotalIncident] = useState(0);
  const [totalCollected, setTotalCollected] = useState(0);
  const [totalEfficiency, setTotalEfficiency] = useState(0);
  const [latestTime, setLatestTime] = useState('');

  const { latest, token } = props;
  
  const [dishes, setDishes] = useState([]);
  const [deviceId, setDeviceId] = useState([]);
  const [date, setDate] = useState(new Date());

  //const [deviceName, setDeviceName] = useState('All Dishes');

  let { siteId } = useParams();
  
  function selectAllDishes(dishes) {
    const templist = [];
    dishes.forEach((dish) => templist.push(dish.dish_id));
    setDeviceId(templist);
  }

  function onTabChange(event, selected){
    setSelectedTab(selected);
  }

  function onDeviceChange(device) {
    const templist = [];
    if (device.target.value === 0) {
      selectAllDishes(dishes);
    } else {
      templist.push(device.target.value);
      setDeviceId(templist);
    }
  }

  function onDateChange(dateValue) {
    setDate(dateValue);
  }

  function cardCallback(newTotalDNI, newTotalCollected, lastTime, incidentValues, collectedValues) {
    setTotalIncident(newTotalDNI);
    setTotalCollected(newTotalCollected);
    setTotalEfficiency(getDaysEfficiencyTotal(newTotalDNI, newTotalCollected));
    setLatestTime(lastTime);
    setDaysCollected(collectedValues);
    setDaysIncident(incidentValues);
  }

  // process any new readings coming in through props
  useEffect(() => {
    if (token){
      //let urlParts = window.location.href.split('/');
      //let siteId =  urlParts[5];
      getDishes(token, siteId).then((json) => { setDishes(json); return json; }).then((json) => selectAllDishes(json));
    }else{
      console.log("token not ready yet");
    }

    const today = new Date();
    if (Object.keys(latest).length !== 0 && date.toDateString() === today.toDateString()) {
      let latestCollected = 0;
      let latestIncident = 0;
      if (deviceId === '*') {
        latestCollected = latest.installationCollectedEnergy;
        latestIncident = latest.installationIncidentEnergy;
      } else {
        latest.concentratorData.forEach((concentrator) => {
          if (concentrator.concentratorId === deviceId) {
            // console.log(concentrator.concentratorReadings);
            latestIncident = concentrator.concentratorReadings.incidentEnergy;
            latestCollected = concentrator.concentratorReadings.collectedEnergy;
          }
        });
      }

      const tempLatestTime = latest.timestamp;
      setLatestTime(tempLatestTime);
      // We have to use copies of the state objs because assignment is asynchronous so we
      // can't count on them being assigned before the next operation
      const copyOfDaysCollected = [...daysCollected];
      const latestCollectedAsKW = ((latestCollected / 60) / 4) / 1000;
      if (latestCollectedAsKW > 0) {
        copyOfDaysCollected.push(latestCollectedAsKW + daysCollected[daysCollected.length - 1]);
      } else {
        copyOfDaysCollected.push(daysCollected[daysCollected.length - 1]);
      }

      const latestIncidentAsKW = ((latestIncident / 60) / 4) / 1000;
      const copyOfDaysIncident = [...daysIncident];
      if (latestIncidentAsKW > 0) {
        copyOfDaysIncident.push(latestIncidentAsKW + daysIncident[daysIncident.length - 1]);
      } else {
        copyOfDaysIncident.push(daysIncident[daysIncident.length - 1]);
      }

      const tempTotalCollected = copyOfDaysCollected[copyOfDaysCollected.length - 1];
      const tempTotalIncident = copyOfDaysIncident[copyOfDaysIncident.length - 1];

      setDaysIncident(copyOfDaysIncident);
      setDaysCollected(copyOfDaysCollected);
      setTotalCollected(tempTotalCollected);
      setTotalIncident(tempTotalIncident);
      setTotalEfficiency(getDaysEfficiencyTotal(tempTotalIncident, tempTotalCollected));
    } else {
      // user selected different day. No need to update
      // or Duplicate message. Ignore it
    }
  }, [props]);

  const cardStyle = {
    display: "block",
    height: "100%"
  };

  const dishSelectStyle = {
    width:"100%",
    display: "flex",
    marginRight:'2%'
  }

  return (
    <div>
      <Helmet>
        <title>Dashboard</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3
        }}
      >
        <Container maxWidth={true}>
          <Grid
            container
            spacing={3}
          >
            <Grid
              item
              lg={4}
              md={12}
              xl={4}
              xs={12}
            >
              <Card style={cardStyle}>
                <CardContent> 
                  <Grid
                    container
                    spacing={3}
                  >
                    <Grid
                      item
                      lg={6}
                      md={6}
                      xl={6}
                      xs={12}
                    > 
                      <InputLabel shrink  id="dish-select-label">Select Dish</InputLabel>
                      <Select
                        style={dishSelectStyle}
                        labelId="dish-select-label"
                        option={dishes}
                        onChange={onDeviceChange}
                        defaultValue={0}
                      >
                        <MenuItem value={0}> All Dishes </MenuItem>
                          {dishes.map((dish) => (
                            <MenuItem value={dish.dish_id} key={dish.dish_serial_no}>
                              {dish.dish_serial_no}
                            </MenuItem>))
                          }
                      </Select> 
                    </Grid>
                    <Grid
                      item
                      lg={6}
                      md={6}
                      xl={6}
                      xs={12}
                    > 
                     <InputLabel shrink  id="date-select-label">Select Date</InputLabel>
                     <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker  
                        labelId="date-select-label"
                        value={date}
                        onChange={onDateChange}
                        format="yyyy-MM-dd"
                        type="day"
                      />
                    </LocalizationProvider>
                   </Grid>
                  </Grid>
                </CardContent>  
              </Card>
            </Grid>
            <Grid
              item
              lg={2}
              sm={6}
              xl={2}
              xs={12}
            >
              <DniCard value={totalIncident} />
            </Grid>
            <Grid
              item
              lg={2}
              sm={6}
              xl={2}
              xs={12}
            >
              <CollectedEnergyCard value={totalCollected} />
            </Grid>
            <Grid
              item
              lg={2}
              sm={6}
              xl={2}
              xs={12}
            >
              <ConversionEfficiencyCard value={totalEfficiency} />
            </Grid>
            <Grid
              item
              lg={2}
              sm={6}
              xl={2}
              xs={12}
            >
              <LastUpdatedCard value={latestTime} sx={{ height: '100%' }} />
            </Grid>
            <Grid
              item
              lg={12}
              md={12}
              xl={12}
              xs={12}
            > 
              <TabContext value={selectedTab}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                  <TabList onChange={onTabChange} aria-label="lab API tabs example">
                    <Tab label="Data View" value="1" />
                    <Tab label="Control View" value="2" />
                  </TabList>
                </Box>
                <TabPanel value="1"><DataDashboard token={token} cardCallback={cardCallback} deviceId={deviceId} date={date}/></TabPanel>
                <TabPanel value="2"><ControlDashboard token={token} deviceId={deviceId}/></TabPanel>
              </TabContext>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </div>
  );
};

Dashboard.propTypes = {
  latest: PropTypes.object,
  token: PropTypes.string
};

export default Dashboard;
